class Image {
  /**
   * Constructor
   */
  constructor() {
    this.baseUrl = process.env.VUE_APP_FILE_URL;
    this.isDev = process.env.NODE_ENV === 'development';
    this.fixedBaseUrl = 'https://cdn.skyfastimg.com';
    this.fixedBaseUrlSkywarex = 'https://cdn.skywarex.com';
  }

  /**
   * Get image url
   */
  url(pathOrigin, resize) {
    if (!pathOrigin) return '';
    let path = pathOrigin;
    if (!path) return;
    // console.log(pathOrigin);
    // console.log('path', path);
    if (path.includes('https://minio.dropnoxe.com/dev')) {
      path = path.replace('https://minio.dropnoxe.com/dev/', '/');
    }
    if (resize && !path.includes('/resize/') && !path.includes(`${this.baseUrl}`)) {
      path = `${path}?w=${resize.width}&h=${resize.height}&q=80`;
    }
    if (!resize && !path.includes('/resize/') && !path.includes(`${this.baseUrl}`)) {
      path = `${path}?w=50&h=50&q=80`;
    }
    if (path.includes(`${this.baseUrl}`)) {
      //image oldold
      return path && (path.includes('https://') || path.includes('data:image') || path.includes('http://'))
        ? path
        : this.baseUrl + (path.startsWith('/') ? path.slice(1) : path);
    } else {
      return path && (path.includes('https://') || path.includes('data:image') || path.includes('http://'))
        ? pathOrigin
        : this.baseUrl + (path.startsWith('/') ? path.slice(1) : path);
    }
  }

  /**
   * Resize image
   */
  resize(path, width, crop) {
    return this.url(path);
  }

  relativeUrl(pathOrigin, resize) {
    if (!pathOrigin) return '';
    let path = pathOrigin;
    if (this.isDev) {
      if (path.includes('/uploads/') && !path.startsWith('http')) {
        path = this.fixedBaseUrl + path.replace('/uploads/', '/');
      } else if (pathOrigin.includes(this.fixedBaseUrl) || pathOrigin.includes(this.fixedBaseUrlSkywarex)) {
        path = pathOrigin;
      } else {
        path = this.fixedBaseUrl + path;
      }
      return path;
    }
    if (path.includes('/uploads/') && !path.startsWith('http')) {
      path = `${path}`;
    }
    if (!path.startsWith('/uploads') && !path.startsWith('http')) {
      path = `/uploads${path}`;
    }
    if (resize && (!path.includes('w=') || !path.includes('h='))) {
      path = `${path}?w=${resize.width}&h=${resize.height}&q=80`;
    }
    return path;
  }
}

export default new Image();
